import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * App Dialog Component - Wrapper for MUI Dialog
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppDialogComponent
 */
const AppDialogComponent = ({
  open = false,
  onClose,
  title,
  children,
  actions,
  maxWidth = 'sm',
  fullWidth = true,
  showCloseButton = true,
  ...props
}) => {
  // Return/rendering
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      {...props}
    >
      {title && (
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pb: 2
          }}
        >
          {title}
          {showCloseButton && onClose && (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                color: 'grey.500',
                '&:hover': {
                  color: 'grey.700'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}
      
      {children && (
        <DialogContent
          sx={{
            pt: title ? 1 : 3,
            pb: 2
          }}
        >
          {children}
        </DialogContent>
      )}
      
      {actions && (
        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            pt: 1
          }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

AppDialogComponent.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  fullWidth: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  sx: PropTypes.object,
};

export default AppDialogComponent;

